import { ConfigResolver } from '../../loader/essentials/config-resolver.js';
import { Registry } from '../../loader/registry.js';
import { GlobalSettings } from '../modules/global-settings/global-settings.js';

interface AdslotLike {
    slotName: string;
}

interface ConstructAdUnitPathOptions {
    addDfpChildID?: boolean;
    addDfpZonePostfix?: boolean;
    addNetworkId?: boolean;
}

const SLASH = '/';
const prefixIfValue = (prefix: string, value: string): string => value ? `${prefix}${value}` : '';

export const constructAdUnitPath = ({ slotName }: AdslotLike, { addDfpChildID = true, addDfpZonePostfix = true, addNetworkId = true, }: ConstructAdUnitPathOptions = {}): string => {
    const globalSettings = Registry.lookup<GlobalSettings>('GlobalSettings');
    const configResolver = Registry.lookup<ConfigResolver>('ConfigResolver');

    const { dfpNetwork = '4444', dfpChildID = '', dfpDesktopName = '', dfpMobileName = '' } = configResolver.getCommonSettings();
    const { isMobileSlot = false, dfpZonePostfix = '', dfpPostUnit = '' } = configResolver.getPositionSettings(slotName) || {};
    const pageType = globalSettings.getPageType();
    const zone = globalSettings.getZone();
    const zoneExtension = globalSettings.getSubZone();

    return [
        prefixIfValue(SLASH, addNetworkId ? dfpNetwork : ''),
        prefixIfValue(',', addNetworkId && addDfpChildID ? dfpChildID : ''),
        SLASH,
        isMobileSlot ? dfpMobileName : dfpDesktopName,
        SLASH,
        zone,
        prefixIfValue(SLASH, zoneExtension),
        prefixIfValue('_', pageType),
        addDfpZonePostfix ? dfpZonePostfix : '',
        prefixIfValue(SLASH, dfpPostUnit),
    ].join('');
};
